module.exports = __webpack_public_path__ + "img/new_index_cases7.ed4963c3.jpg";